__turbopack_context__.v({
  "address": "CardLocation-module-scss-module___6BJta__address",
  "buttonWrapper": "CardLocation-module-scss-module___6BJta__buttonWrapper",
  "contactEmail": "CardLocation-module-scss-module___6BJta__contactEmail",
  "contactLabel": "CardLocation-module-scss-module___6BJta__contactLabel",
  "contactName": "CardLocation-module-scss-module___6BJta__contactName",
  "contactNumber": "CardLocation-module-scss-module___6BJta__contactNumber",
  "contactWrapper": "CardLocation-module-scss-module___6BJta__contactWrapper",
  "hoursLabel": "CardLocation-module-scss-module___6BJta__hoursLabel",
  "hoursList": "CardLocation-module-scss-module___6BJta__hoursList",
  "hoursWrapper": "CardLocation-module-scss-module___6BJta__hoursWrapper",
  "learnMoreLink": "CardLocation-module-scss-module___6BJta__learnMoreLink",
  "locationCard": "CardLocation-module-scss-module___6BJta__locationCard",
  "logoWrapper": "CardLocation-module-scss-module___6BJta__logoWrapper",
  "market": "CardLocation-module-scss-module___6BJta__market",
  "reservationButton": "CardLocation-module-scss-module___6BJta__reservationButton",
  "timeSpan": "CardLocation-module-scss-module___6BJta__timeSpan",
});
